<template>
    <div class="object-modal">
        <h3 class="map-modal__title">{{ title }}</h3>
        <div class="map-modal__content" v-html="content"></div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String
        },
        content: {
            type: String,
            default: ""
        }
    },

    data() {
        return {};
    }
};
</script>
